import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { MdAdd } from 'react-icons/md';
import { ChallengeComponentInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import ChallengeModal from '../../../../account/challenges/ChallengeModal';
import ChallengeSettingsForm from '../../../../account/challenges/ChallengeSettingsForm';
import VyTooltip from '../../../../common/VyTooltip';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

interface ChallengeSettingsTableInterface {
  component: ChallengeComponentInterface;
  onChange: (c: ChallengeComponentInterface) => void;
}

const ChallengeSettingsTable = ({ component, onChange }: ChallengeSettingsTableInterface) => {
  const { t } = useTranslation(['pagebuilder']);

  const challenges = useSelector((state) => state.common.challenges);

  const [isAddModal, setIsAddModal] = useState<boolean>(false);

  const settingSections: PageBuilderSettingsSection[] = [
    {
      name: t('account:challenges.challenges'),
      actions: [
        {
          icon: (
            <VyTooltip title={t('account:challenges.add-challenge')}>
              <MdAdd />
            </VyTooltip>
          ),
          onClick: () => {
            setIsAddModal(true);
          },
        },
      ],
      settings: [
        {
          hasDefaultPadding: false,
          content: <ChallengeSettingsForm />,
        },
      ],
    },
    {
      name: t('pagebuilder:select-challenge'),
      settings: [
        {
          path: 'challenge',
          type: 'select',
          defaultValue: component.challenge,
          selectItems: challenges.map((c) => ({ name: c.name, value: c._id })),
        },
      ],
    },
  ];
  return (
    <>
      <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} />
      <ChallengeModal
        open={isAddModal}
        onClose={() => {
          setIsAddModal(false);
        }}
      />
    </>
  );
};
export default ChallengeSettingsTable;
